import { api } from "../client";
import {
  CommissionScopeTypeFields,
  PartialCommissionScopeTypeFields,
} from "../schema/CommissionScopeType";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<CommissionScopeTypeFields>;
type ApiRequestConfigMutate = ConfigMutate<PartialCommissionScopeTypeFields>;

export const getCommissionScopeTypes = async (config?: ApiRequestConfig) => {
  return api.get<CommissionScopeTypeFields>("commission_scope_types", config);
};
export const getCommissionScopeType = (
  id: number,
  config?: ApiRequestConfig
) => {
  return api.get<CommissionScopeTypeFields>(
    `commission_scope_types/${id}`,
    config
  );
};

export const createCommissionScopeType = (config: ApiRequestConfigMutate) => {
  return api.create<PartialCommissionScopeTypeFields, {}>(
    "commission_scope_types",
    config
  );
};
export const updateCommissionScopeType = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialCommissionScopeTypeFields, {}>(
    `commission_scope_types/${id}`,
    config
  );
};
export const deleteCommissionScopeType = (id: number) => {
  return api.remove<CommissionScopeTypeFields>(`commission_scope_types/${id}`);
};
